<template>
  <div class="p-register">
    <div class="title">填写注册信息</div>
    <el-form class="form-body">
      <el-form-item>
        <div class="box">
          <span class="name">公司名</span>
          <input
            v-model="info.ContactCompanyName"
            type="text"
            placeholder="请输入公司名称"
          />
        </div>
      </el-form-item>
      <el-form-item class="item">
        <div class="box">
          <span class="name">联系人</span>
          <input
            v-model="info.ContactName"
            type="text"
            placeholder="输入联系人"
          />
        </div>
      </el-form-item>
      <el-form-item class="item">
        <div class="box">
          <span class="name">手机号码</span>
          <input
            type="tel"
            v-model="info.PhoneNumber"
            maxlength="11"
            placeholder="输入手机号码"
          />
        </div>
      </el-form-item>
      <el-form-item class="item">
        <div class="box">
          <span class="name">验证码</span>
          <input
            maxlength="6"
            v-model="info.SmsCode"
            type="text"
            placeholder="填写短信验证码"
          />
          <div @click="getVerifycode" class="auth-btn">获取验证码</div>
        </div>
      </el-form-item>
      <el-form-item class="item">
        <div class="box">
          <span class="name">账号</span>
          <input
            v-model="info.AccountName"
            type="text"
            placeholder="输入账号"
          />
        </div>
      </el-form-item>
      <el-form-item class="item">
        <div class="box">
          <span class="name">密码</span>
          <input
            v-model="info.Password"
            type="password"
            placeholder="输入6-16位密码"
          />
        </div>
      </el-form-item>
    </el-form>
    <el-button
      type="warning"
      :loading="loading"
      @click="register"
      class="register-btn"
      >快速注册
    </el-button>
    <p class="tel">技术支持 <a href="tel:0755-83938470">0755-83938470</a></p>
  </div>
</template>
<script>
import API from "@/api/index";
import { mapState } from "vuex";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      loading: false,
      // info: {
      //   ContactCompanyName: "深圳市正能量网络技术有限公司",
      //   ContactName: "AG",
      //   PhoneNumber: "18718518397",
      //   SmsCode: "77461",
      //   AccountName: "AGGIN",
      //   Password: "123456",
      //   SmsGuid: "123",
      //   openId: "",
      //   AppOpenId: ""
      // },
      info: {
        ContactCompanyName: "",
        ContactName: "",
        PhoneNumber: "",
        SmsCode: "",
        AccountName: "",
        Password: "",
        SmsGuid: "",
        openId: this.$store.state.openId
      }
    };
  },
  computed: {
    ...mapState({
      token: state => state.token,
      openId: state => state.openId
    })
  },
  methods: {
    getVerifycode() {
      if (!this.info.PhoneNumber) {
        this.$message({
          type: "error",
          message: "请输入手机号"
        });
        return false;
      }
      API.getVerifycode(this.info.PhoneNumber).then(res => {
        if (res.Code === 0) {
          this.$message({
            type: "success",
            message: res.Message
          });
          this.info.SmsGuid = res.Data;
        } else {
          this.$message({
            type: "error",
            message: "短信发送失败,请稍后再试"
          });
        }
      });
    },
    register() {
      let error = "";
      if (!this.info.SmsGuid) {
        error = "请先获取验证码";
      } else if (!this.info.ContactCompanyName) {
        error = "请输入公司名";
      } else if (!this.info.ContactName) {
        error = "请输入联系人名称";
      } else if (!this.info.SmsCode) {
        error = "请输入验证码";
      } else if (!this.info.AccountName) {
        error = "请输入账号";
      } else if (
        this.info.Password.length <= 6 ||
        this.info.Password.length > 16
      ) {
        error = "请输入6-16位密码";
      }
      if (error) {
        this.$message({
          type: "error",
          message: error
        });
        return false;
      }
      // 验证结束开始注册
      API.register(this.info).then(res => {
        if (!res) {
          this.$message({
            type: "error",
            message: "注册发生错误，请稍后再试！"
          });
          return false;
        }
        if (res.Code === 0) {
          this.$message({
            type: "success",
            message: "注册成功！"
          });
          const token = res.Data.Token;
          this.$store.commit("setToken", token);
          Cookies.set("luck-token", token);
          this.$router.push({
            name: "luck"
          });
        } else {
          this.$message({
            type: "error",
            message: res.Message
          });
        }
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.p-register {
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;

  .title {
    padding: 0 12px;
    font-weight: bold;
    font-size: 16px;
    line-height: 44px;
    color: #333;
  }

  .auth-btn {
    display: flex;
    align-items: center;
    height: 100%;
    white-space: nowrap;
    border-left: 1px solid #e5e5e5;
    padding: 0 10px;
    color: #ee7700;
  }

  .register-btn {
    display: block;
    margin: 24px auto;
    width: 95%;
    height: 45px;
    font-weight: normal;
    font-size: 16px;
    background-color: #ee7700;
  }

  .tel {
    text-align: center;
    font-size: 12px;
    color: #999999;

    a {
      color: #4a90e2;
    }
  }

  .form-body {
    background-color: #fff;

    input {
      width: 100%;
      letter-spacing: 0.5px;
      background-color: transparent;
      outline: none;
      font-size: 16px;
      border: none;

      &::placeholder {
        color: #ccc;
      }
    }

    .el-form-item {
      padding-left: 15px;
      height: 44px;
      margin: 0;
      border-bottom: 1px solid #e5e5e5;

      .box {
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 44px;
        width: 100%;
        height: 100%;
      }

      .name {
        display: block;
        flex-shrink: 0;
        width: 100px;
        color: #333;
      }
    }
  }
}
</style>
